// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CONTENEDOR GENERAL DE LA PANTALLA */
.correos-container {
    background-color: var(--app-fondo);
    color: var(--texto-principal);
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    font-family: var(--font-principal);
}

/* MAIN */
.correos-main {
    padding: 32px;
    flex: 1 1;
    margin: 0px 80px;
}

/* FILTROS */
.toolbar-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    gap: 20px;
    margin-bottom: 25px;

    background: var(--bg-card);
    padding: 20px;
    border-radius: 12px;
    box-shadow: var(--sombra-card);
    border: 1px solid var(--color-borders);
}

/* Search Wrapper */
.search-wrapper {
    position: relative;
    flex: 2 1;
    min-width: 450px;
}

.search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--color-gray-text);
    font-size: 1.2rem;
}

/* Input de busqueda general */
.search-input {
    width: 100%;
    padding: 10px 12px 10px 45px;
    border: 1px solid var(--color-borders);
    background-color: var(--bg-input);
    color: var(--texto-principal);
    border-radius: 8px;
    font-size: 14px;
    outline: none;
    transition: all 0.2s;
}

/* Contenedor de filtros y checkbox*/
.filtros-secundarios {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-wrap: nowrap;
}

/* Filtros Item */
.filtro-item {
    display: flex;
    align-items: center;
}


/* Inputs de filtros */
.filter-select,
.datepicker-input {
    padding: 10px 12px;
    border: 1px solid var(--color-borders);
    border-radius: 8px;
    background-color: var(--bg-input);
    color: var(--texto-principal);
    font-size: 14px;
    cursor: pointer;
    height: 40px;
    box-sizing: border-box;
}
.datepicker-input::placeholder {
    color: var(--texto-principal);
    opacity: 1;
}


/* Focus */
.search-input:focus,
.filter-select:focus,
.datepicker-input:focus {
    border-color: var(--primary-blue);
    box-shadow: 0 0 0 3px rgba(67, 56, 202, 0.1);
}

/* Datepicker popper */
.react-datepicker-popper {
    box-shadow: var(--sombra-card);
}

/* Días seleccionados */
.react-datepicker__day--selected,
.react-datepicker__day--keyboard-selected {
    background-color: var(--primary-blue) !important;
    color: white !important;
    border-radius: 4px !important;
}

/* Hover */
.react-datepicker__day:hover {
    background-color: #dcd8ff !important;
    border-radius: 4px !important;
}

/* Checkbox "Mostrar Mis Correos" */
.checkbox-mios {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
    color: var(--primary-blue);
    cursor: pointer;
    height: 40px;
}

.checkbox-mios input[type="checkbox"] {
    accent-color: var(--primary-blue);
    cursor: pointer;
}


/* TABLA */
.tabla-container {
    border-radius: 12px;
    box-shadow: var(--sombra-card);
    overflow: hidden;
}

.correos-tabla tr {
    background-color: var(--bg-card);
} 
.correos-tabla {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
}

.correos-tabla th,
.correos-tabla td {
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 14px 18px;
    border-bottom: 1px solid var(--color-light-bg);
}

/* Encabezados */
.correos-tabla th {
    background-color: var(--bg-card);
    color: var(--primary-blue);
    text-transform: uppercase;
    font-size: 20px;
    font-weight: 600;
}

/* Column widths */

.correos-tabla th:nth-child(1),
.correos-tabla td:nth-child(1) {
    width: 30%;
    /* Destinatario */
}

.correos-tabla th:nth-child(2),
.correos-tabla td:nth-child(2) {
    width: 40%;
    /* Asunto */
}

.correos-tabla th:nth-child(3),
.correos-tabla td:nth-child(3) {
    width: 20%;
    /* Fecha de envío */
}

.correos-tabla th:nth-child(4),
.correos-tabla td:nth-child(4) {
    width: 10%;
    /* Usuario */
    text-align: center;
}

.correos-tabla th:nth-child(5),
.correos-tabla td:nth-child(5) {
    width: 10%;
    /* Ver detalle */
    text-align: center;
}


/* Botón acción */
.accion-boton {
    background: none;
    border: none;
    color: var(--primary-blue);
    cursor: pointer;
    font-size: 20px;
    transition: opacity .2s;
}

.accion-boton:hover {
    opacity: 0.7;
}

/*  PAGINACIÓN*/
.paginacion {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 24px;
}

.paginacion p {
    font-size: 14px;
    color: var(--color-gray-text);
}

.paginacion-botones {
    display: flex;
    gap: 6px;
}

.paginacion-botones button {
    padding: 6px 12px;
    border-radius: 6px;
    border: 1px solid var(--color-light-bg);
    background: var(--color-light-bg);
    cursor: pointer;
    transition: background .2s ease;
}

.paginacion-botones button:hover {
    background: #e5e7eb;
}

.paginacion-botones .activo {
    background-color: var(--primary-blue);
    color: white;
}

.paginacion-botones button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/pages/CorreosEnviados/CorreosEnviados.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;IACI,kCAAkC;IAClC,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA,SAAS;AACT;IACI,aAAa;IACb,SAAO;IACP,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;IACT,mBAAmB;;IAEnB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sCAAsC;AAC1C;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA,8BAA8B;AAC9B;IACI,WAAW;IACX,4BAA4B;IAC5B,sCAAsC;IACtC,iCAAiC;IACjC,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,oBAAoB;AACxB;;AAEA,oCAAoC;AACpC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;AACrB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,mBAAmB;AACvB;;;AAGA,sBAAsB;AACtB;;IAEI,kBAAkB;IAClB,sCAAsC;IACtC,kBAAkB;IAClB,iCAAiC;IACjC,6BAA6B;IAC7B,eAAe;IACf,eAAe;IACf,YAAY;IACZ,sBAAsB;AAC1B;AACA;IACI,6BAA6B;IAC7B,UAAU;AACd;;;AAGA,UAAU;AACV;;;IAGI,iCAAiC;IACjC,4CAA4C;AAChD;;AAEA,sBAAsB;AACtB;IACI,8BAA8B;AAClC;;AAEA,uBAAuB;AACvB;;IAEI,gDAAgD;IAChD,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA,UAAU;AACV;IACI,oCAAoC;IACpC,6BAA6B;AACjC;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,iCAAiC;IACjC,eAAe;AACnB;;;AAGA,UAAU;AACV;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA,gBAAgB;AAChB;IACI,gCAAgC;IAChC,0BAA0B;IAC1B,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;;AAEA,kBAAkB;;AAElB;;IAEI,UAAU;IACV,iBAAiB;AACrB;;AAEA;;IAEI,UAAU;IACV,WAAW;AACf;;AAEA;;IAEI,UAAU;IACV,mBAAmB;AACvB;;AAEA;;IAEI,UAAU;IACV,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;AACtB;;;AAGA,iBAAiB;AACjB;IACI,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,uCAAuC;IACvC,iCAAiC;IACjC,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":["/* CONTENEDOR GENERAL DE LA PANTALLA */\r\n.correos-container {\r\n    background-color: var(--app-fondo);\r\n    color: var(--texto-principal);\r\n    min-height: 100vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    font-family: var(--font-principal);\r\n}\r\n\r\n/* MAIN */\r\n.correos-main {\r\n    padding: 32px;\r\n    flex: 1;\r\n    margin: 0px 80px;\r\n}\r\n\r\n/* FILTROS */\r\n.toolbar-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    flex-wrap: nowrap;\r\n    gap: 20px;\r\n    margin-bottom: 25px;\r\n\r\n    background: var(--bg-card);\r\n    padding: 20px;\r\n    border-radius: 12px;\r\n    box-shadow: var(--sombra-card);\r\n    border: 1px solid var(--color-borders);\r\n}\r\n\r\n/* Search Wrapper */\r\n.search-wrapper {\r\n    position: relative;\r\n    flex: 2;\r\n    min-width: 450px;\r\n}\r\n\r\n.search-icon {\r\n    position: absolute;\r\n    left: 12px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    color: var(--color-gray-text);\r\n    font-size: 1.2rem;\r\n}\r\n\r\n/* Input de busqueda general */\r\n.search-input {\r\n    width: 100%;\r\n    padding: 10px 12px 10px 45px;\r\n    border: 1px solid var(--color-borders);\r\n    background-color: var(--bg-input);\r\n    color: var(--texto-principal);\r\n    border-radius: 8px;\r\n    font-size: 14px;\r\n    outline: none;\r\n    transition: all 0.2s;\r\n}\r\n\r\n/* Contenedor de filtros y checkbox*/\r\n.filtros-secundarios {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 20px;\r\n    flex-wrap: nowrap;\r\n}\r\n\r\n/* Filtros Item */\r\n.filtro-item {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n\r\n/* Inputs de filtros */\r\n.filter-select,\r\n.datepicker-input {\r\n    padding: 10px 12px;\r\n    border: 1px solid var(--color-borders);\r\n    border-radius: 8px;\r\n    background-color: var(--bg-input);\r\n    color: var(--texto-principal);\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    height: 40px;\r\n    box-sizing: border-box;\r\n}\r\n.datepicker-input::placeholder {\r\n    color: var(--texto-principal);\r\n    opacity: 1;\r\n}\r\n\r\n\r\n/* Focus */\r\n.search-input:focus,\r\n.filter-select:focus,\r\n.datepicker-input:focus {\r\n    border-color: var(--primary-blue);\r\n    box-shadow: 0 0 0 3px rgba(67, 56, 202, 0.1);\r\n}\r\n\r\n/* Datepicker popper */\r\n.react-datepicker-popper {\r\n    box-shadow: var(--sombra-card);\r\n}\r\n\r\n/* Días seleccionados */\r\n.react-datepicker__day--selected,\r\n.react-datepicker__day--keyboard-selected {\r\n    background-color: var(--primary-blue) !important;\r\n    color: white !important;\r\n    border-radius: 4px !important;\r\n}\r\n\r\n/* Hover */\r\n.react-datepicker__day:hover {\r\n    background-color: #dcd8ff !important;\r\n    border-radius: 4px !important;\r\n}\r\n\r\n/* Checkbox \"Mostrar Mis Correos\" */\r\n.checkbox-mios {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    font-weight: 500;\r\n    color: var(--primary-blue);\r\n    cursor: pointer;\r\n    height: 40px;\r\n}\r\n\r\n.checkbox-mios input[type=\"checkbox\"] {\r\n    accent-color: var(--primary-blue);\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n/* TABLA */\r\n.tabla-container {\r\n    border-radius: 12px;\r\n    box-shadow: var(--sombra-card);\r\n    overflow: hidden;\r\n}\r\n\r\n.correos-tabla tr {\r\n    background-color: var(--bg-card);\r\n} \r\n.correos-tabla {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    table-layout: fixed;\r\n}\r\n\r\n.correos-tabla th,\r\n.correos-tabla td {\r\n    text-align: left;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    padding: 14px 18px;\r\n    border-bottom: 1px solid var(--color-light-bg);\r\n}\r\n\r\n/* Encabezados */\r\n.correos-tabla th {\r\n    background-color: var(--bg-card);\r\n    color: var(--primary-blue);\r\n    text-transform: uppercase;\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n}\r\n\r\n/* Column widths */\r\n\r\n.correos-tabla th:nth-child(1),\r\n.correos-tabla td:nth-child(1) {\r\n    width: 30%;\r\n    /* Destinatario */\r\n}\r\n\r\n.correos-tabla th:nth-child(2),\r\n.correos-tabla td:nth-child(2) {\r\n    width: 40%;\r\n    /* Asunto */\r\n}\r\n\r\n.correos-tabla th:nth-child(3),\r\n.correos-tabla td:nth-child(3) {\r\n    width: 20%;\r\n    /* Fecha de envío */\r\n}\r\n\r\n.correos-tabla th:nth-child(4),\r\n.correos-tabla td:nth-child(4) {\r\n    width: 10%;\r\n    /* Usuario */\r\n    text-align: center;\r\n}\r\n\r\n.correos-tabla th:nth-child(5),\r\n.correos-tabla td:nth-child(5) {\r\n    width: 10%;\r\n    /* Ver detalle */\r\n    text-align: center;\r\n}\r\n\r\n\r\n/* Botón acción */\r\n.accion-boton {\r\n    background: none;\r\n    border: none;\r\n    color: var(--primary-blue);\r\n    cursor: pointer;\r\n    font-size: 20px;\r\n    transition: opacity .2s;\r\n}\r\n\r\n.accion-boton:hover {\r\n    opacity: 0.7;\r\n}\r\n\r\n/*  PAGINACIÓN*/\r\n.paginacion {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-top: 24px;\r\n}\r\n\r\n.paginacion p {\r\n    font-size: 14px;\r\n    color: var(--color-gray-text);\r\n}\r\n\r\n.paginacion-botones {\r\n    display: flex;\r\n    gap: 6px;\r\n}\r\n\r\n.paginacion-botones button {\r\n    padding: 6px 12px;\r\n    border-radius: 6px;\r\n    border: 1px solid var(--color-light-bg);\r\n    background: var(--color-light-bg);\r\n    cursor: pointer;\r\n    transition: background .2s ease;\r\n}\r\n\r\n.paginacion-botones button:hover {\r\n    background: #e5e7eb;\r\n}\r\n\r\n.paginacion-botones .activo {\r\n    background-color: var(--primary-blue);\r\n    color: white;\r\n}\r\n\r\n.paginacion-botones button:disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
